// Foreign-locale prefixes too — stacking them breaks subject-based threading in some clients
const KNOWN_REPLY_PREFIXES = ['re:', 'sv:', 'aw:', 'antw:', 'vs:'];
export const replySubject = (originalSubject, localizedPrefix) => {
    const replyPrefix = localizedPrefix?.trim() || 'Re:';
    const trimmedSubject = originalSubject?.trim() ?? '';
    if (!trimmedSubject) {
        return replyPrefix;
    }
    const lowerSubject = trimmedSubject.toLowerCase();
    const replyPrefixes = new Set([
        replyPrefix.toLowerCase(),
        ...KNOWN_REPLY_PREFIXES,
    ]);
    for (const knownPrefix of replyPrefixes) {
        if (lowerSubject.startsWith(knownPrefix)) {
            return trimmedSubject;
        }
    }
    return `${replyPrefix} ${trimmedSubject}`;
};
export const replyHeaders = (sourceDetails) => {
    const inReplyTo = sourceDetails.imapId ?? null;
    const existingReferences = sourceDetails.references ?? null;
    if (!inReplyTo) {
        return {
            inReplyTo,
            references: existingReferences,
        };
    }
    return {
        inReplyTo,
        references: existingReferences
            ? `${existingReferences} ${inReplyTo}`
            : inReplyTo,
    };
};
export const replyRecipient = (sourceDetails) => sourceDetails.replyTo || sourceDetails.from || null;
// Most direct parent first: In-Reply-To, then References from newest to oldest
export const threadMessageIds = (details) => {
    const inReplyTo = details.inReplyTo?.match(/<[^<>\s]+>/g) ?? [];
    const references = details.references?.match(/<[^<>\s]+>/g) ?? [];
    return [...new Set([...inReplyTo, ...references.toReversed()])];
};
//# sourceMappingURL=reply.js.map